const contactSectionSelector = '[data-contact-form-section]';
const contactAnchorHashes = new Set(['#contact', '#footer_contact_form']);

const getSamePageContactHash = (link) => {
  const url = new URL(link.href, window.location.href);
  const pathname = url.pathname.replace(/\/+$/, '') || '/';

  const currentPathname = window.location.pathname.replace(/\/+$/, '') || '/';
  const isSamePage = url.origin === window.location.origin && pathname === currentPathname;

  if (!isSamePage || !contactAnchorHashes.has(url.hash)) {
    return null;
  }

  return url.hash;
};

const getContactSection = (hash) => {
  if (hash === '#footer_contact_form') {
    return document.getElementById('footer_contact_form');
  }

  return document.querySelector(contactSectionSelector);
};

const closeMobileMenu = () => {
  const header = document.querySelector('.header');

  if (!header?.classList.contains('is-open-menu')) return;

  const burgerButton = document.querySelector('.burger-btn');

  if (burgerButton) {
    burgerButton.click();
    return;
  }

  header.classList.remove('is-open-menu');
  document.querySelector('.menu-toggle')?.classList.remove('active');
  document.querySelector('.navbar-nav')?.classList.remove('active');
  document.querySelector('.header-close-wrapper')?.classList.remove('active');
  window.lenis?.start();
};

const scrollToContactSection = (section) => {
  const headerOffset = document.querySelector('.header')?.offsetHeight || 0;

  if (section.id && typeof window.scrollToEl === 'function') {
    window.scrollToEl(`#${section.id}|800|${headerOffset}`);
    return;
  }

  const top = section.getBoundingClientRect().top + window.scrollY - headerOffset;
  window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
};

if (!document.documentElement.dataset.contactNavigationInitialized) {
  document.documentElement.dataset.contactNavigationInitialized = 'true';

  document.addEventListener('click', (event) => {
    if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;

    const link = event.target instanceof Element ? event.target.closest('a[href]') : null;
    if (!link || (link.target && link.target !== '_self')) return;

    const contactHash = getSamePageContactHash(link);
    if (!contactHash) return;

    const localContactSection = getContactSection(contactHash);
    if (!localContactSection) return;

    event.preventDefault();
    closeMobileMenu();
    window.requestAnimationFrame(() => scrollToContactSection(localContactSection));
  });
}
